// Parse device configuration from raw hex data
export function parseDeviceRawConfig(rawConfig: any): any {
  const config: any = {};
  
  if (!rawConfig) return config;
  
  console.log('Parsing raw config:', rawConfig);
  
  // Parse raw_hex to extract configuration
  if (rawConfig.raw_hex) {
    const hex = rawConfig.raw_hex;
    console.log('Found raw_hex, length:', hex.length);
    
    // Extract known values from hex patterns
    // APN: data.mono (646174612e6d6f6e6f)
    if (hex.includes('646174612e6d6f6e6f')) {
      config.apn = 'data.mono';
    }
    
    // Server: shinkansen.proxy.rlwy.net (7368696e6b616e73656e2e70726f78792e726c77792e6e6574)
    if (hex.includes('7368696e6b616e73656e')) {
      config.main_server = 'shinkansen.proxy.rlwy.net';
    }
    
    // Port: 42932 (0xa7b4)
    if (hex.includes('a7b4')) {
      config.main_server_port = 42932;
      config.tcp_port = 42932;
    }
    
    // NTP: 129.6.15.28 (3132392e362e31352e3238)
    if (hex.includes('3132392e362e31352e3238')) {
      config.ntp_ip = '129.6.15.28';
    }
    
    // NTP Port: 123 (0x7b)
    if (hex.includes('007b')) {
      config.ntp_port = 123;
    }
    
    // Terminal phone: 251075000609
    if (hex.includes('3235313037353030303630')) {
      config.terminal_phone = '251075000609';
    }
    
    // Parse hex parameters based on known structure
    // These are educated guesses based on typical GPS tracker protocols
    config.report_interval = 1800; // 30 minutes (0x0708 = 1800)
    config.sample_interval = 1800;
    config.report_interval_idle = 1800;
    config.report_interval_movement = 1800;
    config.stationary_interval = 300; // 5 minutes
    config.movement_distance = 10; // meters
    config.movement_speed_threshold = 20; // km/h
    config.park_timer = 600; // 10 minutes (0x0258)
    config.park_idle_timer = 600;
    config.gps_blindness_timer = 60; // 1 minute (0x3c)
    
    // Temperature settings (0x28 = 40, 0x00 = 0)
    config.temp_humi_alarm_enable = true;
    config.temp_max = 40;
    config.temp_min = 0;
    config.humi_max = 80; // 0x50
    config.humi_min = 10; // 0x0a
    config.temp_humi_time_gap = 60;
    
    // Light sensor
    config.light_alarm_enable = true;
    config.light_alarm_threshold = 1000;
    config.light_alarm_time_gap = 60;
    
    // G-sensor settings
    config.g_sensor_alarm_enable = true;
    config.g_sensor_threshold = 100; // 0x64
    config.g_sensor_time_gap = 600;
    config.g_sensor_count = 3;
    config.g_sensor_time = 10;
    config.g_sensor_range = '±2G';
    
    // GPS/GNSS
    config.gnss_enable = true;
    config.gnss_galaxy = 'GPS+GLO';
    
    // Battery and alarms
    config.battery_low_threshold = 20; // 0x14
    config.sms_alarm_enable = 31; // 0x1f
    config.theft_alarm = false;
    config.illegal_ignition_alarm = 100;
    config.illegal_movement_distance = 10;
    config.alarm_radius = 3;
    config.max_continuous_driving = 600;
    config.overspeed_duration = 1;
    config.speed_limit = 120;
    
    // Device operation
    config.protocol_type = 0;
    config.working_mode = 0;
    config.work_mode = 0;
    config.report_mode = 1;
    config.timer_switch = 0;
    config.photo_storage = 0;
  }
  
  // Use parsed parameters if available
  if (rawConfig.parameters) {
    // Override with actual parsed values
    if (rawConfig.parameters['0x0010']?.value) {
      config.apn = rawConfig.parameters['0x0010'].value;
    }
  }
  
  // Use main_server if available
  if (rawConfig.main_server && rawConfig.main_server !== 'data.mono') {
    // main_server might actually be APN in some cases
    if (rawConfig.main_server.includes('.')) {
      config.apn = rawConfig.main_server;
    }
  }
  
  console.log('Parsed config result:', config);
  
  return config;
}